import { all, call } from 'redux-saga/effects';
import watchHealthReport from '../app/containers/health-report/store/saga';

export default function* rootSaga() {
  yield all([call(watchHealthReport)]);
}
